// extracted by mini-css-extract-plugin
module.exports = {"styledDropdownMenu":"FHkjold8"};